import AntdSelect from 'antd/lib/select';
import CustomSelect from './CustomSelect';
var Select = AntdSelect;
Select.CustomSelect = CustomSelect;
export default Select;